import * as _ from 'lodash'
import {IBusinessObject} from '../PA.Core/PA.Core.IF.BO';
import {IDateRange, IMessageProvider, IProgressProvider, MessageType} from '../PA.Core/PA.Core.IF.Basic';
import {PAdbContext} from '../PA.Core/PAdbContext';
import {IdentityProvider} from '../PA.Core/Basic/Identity'
import {MessageProvider} from '../PA.Core/Basic/Messages'
import {ProgressProvider} from '../PA.Core/Basic/Progress'
import {
    WB_PeriodTagRelationshipRow,
    WB_PeriodRelationshipRow,
    WB_PeriodRow,
    WB_TagRow,
    WB_TagSourceRow,
    WB_MasterDataSetRow,
    WB_SourceRow,
    WB_PeriodTypeRow, WB_PeriodCompanyRelationshipRow, WB_CompanyRow,
} from "../PA.Core/PAdbSchemaRows";
import {IwbPeriod} from "../PA.Core/PAdbSchemaRowsIF";
import {
    esWB_Period,
    esWB_Period_Relationship,
    esWB_Tag,
    esWB_Period_Tag_Relationship,
    esWB_Tag_Source,
    esWB_Period_Type, esWB_MasterData_Set, esWB_Source, esWB_Period_Company_Relationship, esWB_Company
} from "../PA.Core/PAdbSchema";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import {CreateOptions, ESRecordResolver} from "../PA.Core/lib/ESRecordResolver";
import {ASync} from "../PA.Core/Basic/ASync";
import {IHaveTags} from "../PA.Core/PA.Core.IF.Aspects";
import {BehaviorSubject} from "rxjs";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {PeriodBOAudit} from "./PeriodBO.Audit";
import {AuditService} from "../PA.Core/Security/AuditService";
import {PeriodBOValidations} from "./PeriodBO.Validation";
import {MDUsageService} from "../PA.MD.Services/MDUsageService";


export interface IPeriodCreateLoadOptions {
    // Load Options
    dbContext?: PAdbContext
    wbPeriodMId?: number

    // Create Options
    wbMasterDataSetId?: number
    sId?: string
    sKeySetId?: string
    sName?: string
    wbSourceId?: number
    PERIODM_ID?: string,
    wbCompanyId?: number | number[],

}
export interface IPeriodType {
    id: number,
    id_ui: string,
    name: string,

}
const PeriodLoadOptions_default: IPeriodCreateLoadOptions = {}

export class PeriodBO implements IBusinessObject {
    Identity: IdentityProvider;

    CreateOptions: IPeriodCreateLoadOptions;

    LoadOptions: IPeriodCreateLoadOptions;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_Period: WB_PeriodRow;
    _PeriodCompanyRelationship: WB_PeriodCompanyRelationshipRow

    constructor(options?: IPeriodCreateLoadOptions) {

        this.CreateOptions = options || {};

        if ('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({id: 0, name: 'New Period'});

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = null;
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_Period = null;
        this._PeriodCompanyRelationship = undefined
        this.IHaveTagsLoaded_init()
        this.IHaveCompanies_init()
    }

    get WB_Period(): WB_PeriodRow {
        return this.drWB_Period;
    }


    //<editor-fold desc = "IBusinessObject operations">

     LoadNew(options?: IPeriodCreateLoadOptions): Promise<IBusinessObject> {
        const self = this;
        this.LoadProgressProvider.start("Creating Period");
         let internalOnComplete = self._OnLoadComplete = (async() => {
            try {
            self.LoadOptions = options || {};
            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if (this.dbContext == null) {
                var sError = "Unable to determine dbContext for new Period.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);

                return self;
            }

            // Create record using dbContext
            let newPeriodRow: WB_PeriodRow = <WB_PeriodRow>await self.dbContext.createRecordWithKey(esWB_Period)

            newPeriodRow.setDefaults()
            self.drWB_Period = newPeriodRow;
            self.dbContext.add(esWB_Period, newPeriodRow)
            self.Identity.setAll(self.WB_Period.cif.WB_PERIOD_ID, self.WB_Period.cif.PERIOD_ID, self.WB_Period.cif.PERIOD_NAME);
            self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
            self.LoadProgressProvider.finish();
            self._bIsLoaded = true;
            self._OnLoadComplete = null;
            await  self.applyCreateOptions();
            self.Identity.setAll(self.WB_Period.cif.WB_PERIOD_ID, self.WB_Period.cif.PERIOD_ID, self.WB_Period.cif.PERIOD_NAME);
            await  self.IPeriodType_OnLoadComplete();
            self.LoadProgressProvider.finish();
            return self

            } catch (err) {
                self.LoadProgressProvider.exception(err)
                return self
            }
        })();

        return internalOnComplete;
    }

    async applyCreateOptions() {
        const self = this

        let sId = self.CreateOptions?.sId || self.LoadOptions?.sId
        if (!_.isEmpty(sId))
            self.WB_Period.cif.PERIOD_ID = sId

        let sName = self.CreateOptions?.sName || self.LoadOptions?.sName
        if (!_.isEmpty(sName))
            self.WB_Period.cif.PERIOD_NAME = sName


        let sKeySetId = self.CreateOptions?.sKeySetId || self.LoadOptions?.sKeySetId
        if (!_.isEmpty(sKeySetId))
            self.WB_Period.cif.PERIOD_SET_ID = sKeySetId

        // Set Master Data Set
        let wbMasterDataSet = self.CreateOptions?.wbMasterDataSetId || self.LoadOptions?.wbMasterDataSetId
        if (_.isNumber(wbMasterDataSet)) {
            let mds: WB_MasterDataSetRow = <any>await self.dbContext.find(esWB_MasterData_Set, wbMasterDataSet)
            if (mds) {
                self.WB_Period.WB_MasterDataSetRow = mds
                self.WB_Period.cif.WB_MDSET_ID = wbMasterDataSet
                let mruValue= new MDUsageService()
                await mruValue.saveMDSetUsage(wbMasterDataSet)
            }
        }

        // Add Company
        let wbCompanyId = self.CreateOptions?.wbCompanyId || self.LoadOptions?.wbCompanyId
        if (_.isNumber(wbCompanyId) && !_.isArray(wbCompanyId))
            wbCompanyId = [wbCompanyId]
        for (let aCompanyId of (wbCompanyId || [])) {
            let newRec = await self.addCompany(aCompanyId)
        }



        // Set Source
        let wbSource = self.CreateOptions?.wbSourceId || self.LoadOptions?.wbSourceId
        if (_.isNumber(wbSource)) {
            let src: WB_SourceRow = <any>await self.dbContext.find(esWB_Source, wbSource)
            if (src) {
                self.WB_Period.cif.SOURCE_ID = src.cif.SOURCE_ID

            }
        }


        // Set Period Type
        let wbPeriodMId= self.CreateOptions?.wbPeriodMId || self.LoadOptions?.wbPeriodMId
        if(_.isNumber(wbPeriodMId)){
            let aValue: WB_PeriodTypeRow = <any> await self.dbContext.find(esWB_Period_Type,wbPeriodMId)
            if(aValue) {
                self.WB_Period.cif.WB_PERIODM_ID = aValue.cif.WB_PERIODM_ID
            }
        }

    }

    Load(anId: number | number, options?: IPeriodCreateLoadOptions): Promise<IBusinessObject> {

        const self = this;

        let recordResolver: ESRecordResolver
        let recordResolverLoadPromise: Promise<void>

        self.LoadProgressProvider.start("Loading (" + anId + ")");

        self._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {

            self.LoadProgressProvider.start("Loading (" + self.Identity.id_ui + ")");

            if (self.bIsLoaded) {
                self.LoadProgressProvider.exception("Period already loaded.");
                self._OnLoadComplete = null;
                resolve(self);
                return;
            }

            self.LoadOptions = options || {};

            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else if (_.isEmpty(self.dbContext)) {
                self.dbContext = new PAdbContext({});
            }

            if (_.isEmpty(self.dbContext)) {
                error("Unable to determine dbContext for Period.")
                return;
            }


            if ('RecordResolver' in self.LoadOptions) {
                recordResolver = (<any>self.LoadOptions).RecordResolver
                recordResolverLoadPromise = ASync.resolve()
            } else {
                recordResolver = PeriodBO.createRecordResolver({dbContext: self.dbContext})
                recordResolverLoadPromise = PeriodBO.setupRecordResolver(recordResolver, [anId])
            }


            recordResolverLoadPromise
                .then(function () {
                    let aPeriodRow: any = recordResolver.get(esWB_Period, anId)

                    if (_.isEmpty(aPeriodRow)) {
                        error("Period not found");
                        return;
                    }

                    self.drWB_Period = aPeriodRow;
                    self.Identity.setAll(self.WB_Period.cif.WB_PERIOD_ID, self.WB_Period.cif.PERIOD_ID, self.WB_Period.cif.PERIOD_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_Period, 'WB_PERIOD_ID', 'PERIOD_ID', 'PERIOD_NAME')
                    let mruValue= new MDUsageService()
                    mruValue.saveMDSetUsage(self.drWB_Period.cif.WB_MDSET_ID)
                })
                .then(() => {
                    self._bIsLoaded = true;
                    self._OnLoadComplete = undefined;
                    self.IPeriodType_OnLoadComplete()
                    self.LoadProgressProvider.finish();
                    resolve(self);
                })
                .catch(function (err: any) {
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.exception(err);
                    error(err);
                });

        });

        return this._OnLoadComplete;
    }


    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }


    async Validate(options?: any): Promise<IBusinessObject> {

        const self = this;
        this.ValidateMessageProvider.clearMessages();
        this.ValidateProgressProvider.start(
            'Validating ' + self.WB_Period.cif.PERIOD_NAME + '(' + self.WB_Period.cif.PERIOD_ID + ')'
        )

        self.ValidateOptions = options || {};

        try {
            if (self.dbContext == undefined) {
                const sError = 'Unable to determine dbContext to validate Period.';
                self.ValidateProgressProvider.exception(sError);
                throw sError;
            }

            await PeriodBOValidations.ValidateFields(self)


            if (self.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                self._bIsValidated = false;
            } else {
                self._bIsValidated = true;
            }
            self.ValidateProgressProvider.finish();

        } catch (err) {
            self._bIsValidated = false;
            self.ValidateProgressProvider.exception(err);

        }
        return self
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }


    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    async SaveUsing(bBatch: boolean, options?: any): Promise<IBusinessObject> {

        var self = this;
        var wbPeriod = <IwbPeriod>self.drWB_Period;
        let auditService: AuditService = undefined

        try {
            this.SaveProgressProvider.start("Saving " + wbPeriod.PERIOD_NAME + "(" + wbPeriod.PERIOD_ID + ")");

            if (this.dbContext == null) {
                self._bIsSaved = false;
                let sError = "Unable to determine dbContext to Save Period.";
                self.SaveProgressProvider.exception(sError);
                return self
            }
            self.SaveOptions = options || {};

            let saveFunction: (esName: string, saveRecords: ESRecord[] | ESRecord, options?: any) => Promise<ESDataStore>
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext)
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext)
            }

                await self.Validate({})

                if (!self.bIsValidated) {
                    self._bIsSaved = false;
                    self.SaveProgressProvider.finish();
                    return self
                }



            auditService = await PeriodBOAudit.PeriodAuditBO(self)


            let tasks: Promise<any>[] = []
            tasks.push(saveFunction(esWB_Period, self.drWB_Period, {}))
            tasks.push(saveFunction(esWB_MasterData_Set, self.drWB_Period.WB_MasterDataSetRow));
            tasks.push(saveFunction(esWB_Period_Type, self.drWB_Period.WB_PeriodTypeRow));
            tasks.push(saveFunction(esWB_Period_Company_Relationship, self.WB_Period.WB_PeriodCompanyRelationshipRow));
            tasks.push(saveFunction(esWB_Period_Relationship, self.drWB_Period.WB_PeriodRelationshipRow_Children))
            tasks.push(saveFunction(esWB_Period_Relationship, self.drWB_Period.WB_PeriodRelationshipRow_Parent))
            tasks.push(saveFunction(esWB_Period_Tag_Relationship, self.drWB_Period.WB_PeriodTagRelationshipRows))

            await Promise.all(tasks)


            if (bBatch) {
                self.dbContext.addBatchCompleteListener(() => {
                    self._bIsSaved = true;
                })
            } else {
                self._bIsSaved = true;
            }
            self.SaveProgressProvider.finish();
            return self
        } catch (err) {
            self.SaveProgressProvider.exception(err);
            return self
        }finally {
            if (auditService)
                await auditService.Save(bBatch)
        }

    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }


//Delete
    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        var self = this;
        var wbPeriod = <IwbPeriod>self.drWB_Period;
        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start("Deleting " + wbPeriod.PERIOD_NAME + "(" + wbPeriod.WB_PERIOD_ID + ")");
        return new Promise<IBusinessObject>((resolve, error) => {

            // 1. Validate if we can delete the Period

            // 2. If Valid, mark all the records for deletion.
            self.drWB_Period.markDeleted()
            _.forEach(self.drWB_Period.WB_PeriodTagRelationshipRows, (esc: WB_PeriodTagRelationshipRow) => {
                if (esc.isActive) {
                    esc.markDeleted()
                }
            })
            _.forEach(self.drWB_Period.WB_PeriodCompanyRelationshipRow, (esc: WB_PeriodCompanyRelationshipRow) => {
                if (esc.isActive) {
                    esc.markDeleted()
                }
            })

            if (bSaveNow) {
                self.SaveUsing(false)
                    .then((ignore) => {
                        self._bIsDeleted = true;
                        self.DeleteProgressProvider.finish();
                        resolve(self);

                    })
                    .catch((err) => {
                        this.DeleteProgressProvider.exception(err)
                        resolve(self)
                    })
            } else {
                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                resolve(self);
            }
        });
    }


    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }

    //</editor-fold>

    addPeriodHierarchy(aWbPeriodId: number, sType: string, aWbPeriodHId: number): Promise<PeriodBO> {

        const self = this

        return new Promise<PeriodBO>((resolve, error) => {
            // first find out if record exists.
            let found = false

            if (sType === 'Child') {
                _.forEach(self.drWB_Period.WB_PeriodRelationshipRow_Children, (aPeriodChildRelRow: WB_PeriodRelationshipRow) => {
                    if (aPeriodChildRelRow.isActive && aPeriodChildRelRow.cif.WB_PERIOD_ID == aWbPeriodId) {
                        found = true
                        return false
                    }
                })
            } else {
                _.forEach(self.drWB_Period.WB_PeriodRelationshipRow_Parent, (aPeriodParentRelRow: WB_PeriodRelationshipRow) => {
                    if (aPeriodParentRelRow.isActive && aPeriodParentRelRow.cif.WB_PERIOD_ID_PRNT == aWbPeriodId) {
                        found = true
                        return false
                    }
                })
            }

            // exists..
            if (found) return

            let aPeriodRow: WB_PeriodRow = undefined
            self.dbContext.find(esWB_Period, aWbPeriodId)
                .then((aPeriodRecord: WB_PeriodRow) => {
                    if (_.isEmpty(aPeriodRecord)) {
                        resolve(self)
                        return
                    }
                    aPeriodRow = aPeriodRecord

                    // create new records
                    return self.dbContext.createRecordWithKey(esWB_Period_Relationship)

                })
                .then((aPeriodRelRow: WB_PeriodRelationshipRow) => {
                    aPeriodRelRow.setDefaults()
                    if (sType === 'Child') {
                        aPeriodRelRow.cif.WB_PERIODH_ID = aWbPeriodId
                        aPeriodRelRow.cif.WB_PERIODH_ID = aWbPeriodHId
                        aPeriodRelRow.WB_PeriodRowChild = aPeriodRow
                        aPeriodRelRow.cif.WB_PERIOD_ID_PRNT = self.drWB_Period.cif.WB_PERIOD_ID
                        aPeriodRelRow.cif.MANUAL_IND = '1'
                    } else {
                        aPeriodRelRow.cif.WB_PERIOD_ID_PRNT = aWbPeriodId
                        aPeriodRelRow.cif.WB_PERIODH_ID = aWbPeriodHId
                        aPeriodRelRow.WB_PeriodRowParent = aPeriodRow
                        aPeriodRelRow.cif.WB_PERIOD_ID = self.drWB_Period.cif.WB_PERIOD_ID
                        aPeriodRelRow.cif.MANUAL_IND = '1'
                    }
                    self.dbContext.add(esWB_Period_Relationship, aPeriodRelRow)
                    resolve(self)
                })
                .catch((err) => {
                    error(err)
                })
        })

    }


    removePeriodHierarchy(aWbPeriodId: number, sType: string): Promise<PeriodBO> {
        const self = this

        return new Promise<PeriodBO>((resolve, error) => {

            if (sType === 'Child') {
                _.forEach(self.drWB_Period.WB_PeriodRelationshipRow_Children, (aPeriodRelRow: WB_PeriodRelationshipRow) => {
                    if (aPeriodRelRow.isActive && aPeriodRelRow.cif.WB_PERIOD_ID == aWbPeriodId) {
                        aPeriodRelRow.markDeleted()
                    }
                })
            } else {
                _.forEach(self.drWB_Period.WB_PeriodRelationshipRow_Parent, (aPeriodRelRow: WB_PeriodRelationshipRow) => {
                    if (aPeriodRelRow.isActive && aPeriodRelRow.cif.WB_PERIOD_ID == aWbPeriodId) {
                        aPeriodRelRow.markDeleted()
                    }
                })
            }

            resolve(self)
        })
    }


    _companyChanged: BehaviorSubject<PeriodBO>

    IHaveCompanies_init() {
        this._companyChanged = new BehaviorSubject<PeriodBO>(this)
    }

    get CompanyChanged(): BehaviorSubject<PeriodBO> {
        return this._companyChanged
    }

    //<editor-fold desc = "Company">
    async addCompany(wbCompanyId: number): Promise<WB_PeriodCompanyRelationshipRow> {
        const self = this

        for (let rel of self.drWB_Period.WB_PeriodCompanyRelationshipRow) {
            if (!rel.isActive)
                continue
            if (rel.cif.WB_COMPANY_ID == wbCompanyId)
                return rel
        }

        let cRow: WB_CompanyRow = await self.dbContext.find(esWB_Company, wbCompanyId)
        if (_.isEmpty(cRow))
            return undefined

        let newPeriodCRRow: WB_PeriodCompanyRelationshipRow = <WB_PeriodCompanyRelationshipRow>await self.dbContext.createRecordWithKey(esWB_Period_Company_Relationship)
        newPeriodCRRow.setDefaults()
        newPeriodCRRow.cif.WB_PERIOD_ID=self.WB_Period.cif.WB_PERIOD_ID
        newPeriodCRRow.cif.WB_COMPANY_ID=wbCompanyId
        newPeriodCRRow.WB_CompanyRow= cRow
        newPeriodCRRow.WB_PeriodRow = self.WB_Period


        self.CompanyChanged.next(self)
        return newPeriodCRRow
    }

    async removeCompany(wbCompanyId: number): Promise<void> {
        const self = this

        for (let rel of self.WB_Period.WB_PeriodCompanyRelationshipRow) {
            if (!rel.isActive)
                continue
            if (rel.cif.WB_PERIODCR_ID == wbCompanyId) {
                rel.markDeleted()
                break
            }
        }

        self.CompanyChanged.next(self)
    }

    //</editor-fold>

    static createRecordResolver(boLoadOptions: any): ESRecordResolver {

        let opts = boLoadOptions || {}
        let dbContext: PAdbContext

        if ('dbContext' in opts) {
            dbContext = opts.dbContext;
        } else {
            dbContext = new PAdbContext({});
        }
        const period_options: CreateOptions = {
            standardConditions: {},
            dctIncludeBelongsToNamedRelations: {}
        }

        const aRecResolver = new ESRecordResolver(dbContext, period_options)

        return aRecResolver;

    }

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {

        return new Promise<void>((resolve, error) => {
            recordResolver.findAllWithRelationships(esWB_Period, ids).then((result) => {
                resolve()
            }).catch((err) => {
                error(err)
            })
        })
    }

    static concurrentLoadCountHint(): number {
        return 10;
    }

    //</editor-fold>

    //<editor-fold desc = "IProductType operations">

    private _PeriodType: IPeriodType

    get PeriodType(): IPeriodType {
        return this._PeriodType
    }
    async IPeriodType_OnLoadComplete(): Promise<void> {
        const self = this

        let ptrow = self.drWB_Period?.WB_PeriodTypeRow
        let ptr = ptrow?.cif


        let bDefaultTrue = _.isEmpty(ptrow)

        let pt: IPeriodType = {
            id: ptr?.WB_PERIODM_ID || 0,
            id_ui: ptr?.PERIOD_TYPE_ID || 'Not Typed',
            name: ptr?.PERIOD_TYPE_NAME ||'Not Typed',

        }

        self._PeriodType = pt

    }

    // IHaveTags
    _bIHaveTagsLoaded: boolean;
    _OnIHaveTagsLoaded: Promise<IHaveTags>;
    _TagsChanged: BehaviorSubject<IHaveTags>;
    _AllTags: WB_TagRow[];
    _TagUsageId: string;


    IHaveTagsLoaded_init() {
        this._bIHaveTagsLoaded = false
        this._OnIHaveTagsLoaded = undefined
        this._TagsChanged = new BehaviorSubject<IHaveTags>(this)
        this._AllTags = undefined
        this._TagUsageId = 'AllTagUsage'

    }

    get bIHaveTagsLoaded() {
        return this._bIHaveTagsLoaded
    }

    get TagsReadOnly(): boolean {
        if (this._bIsDeleted) {
            return true
        }
        // Check User Roles ?

        return false
    }

    get Tags(): WB_TagRow[] {
        var returnValue: WB_TagRow[] = []

        _.forEach(this.drWB_Period.WB_PeriodTagRelationshipRows, (aWBPeriodTagRow: WB_PeriodTagRelationshipRow) => {
            if (aWBPeriodTagRow && aWBPeriodTagRow.isActive && aWBPeriodTagRow.WB_TagRow) {
                returnValue.push(aWBPeriodTagRow.WB_TagRow)
            }
        })

        return returnValue
    }

    get TagsChanged(): BehaviorSubject<IHaveTags> {
        return this._TagsChanged
    }

    get AllTags(): WB_TagRow[] {
        if (this._AllTags) {
            return this._AllTags
        } else {
            return []
        }
    }

    get UsageId(): string {
        return this._TagUsageId
    }

    get OnIHaveTagsLoaded(): Promise<IHaveTags> {
        const self = this;

        if (self._bIHaveTagsLoaded) {
            return ASync.resolve(self)
        }

        if (!_.isEmpty(self._OnIHaveTagsLoaded)) {
            return self._OnIHaveTagsLoaded;
        }

        self._OnIHaveTagsLoaded = new Promise<IHaveTags>((resolve, error) => {
            // If the BO is not loaded, throw an error.. It should have been started
            if ((!(self.bIsLoaded)) && (_.isEmpty(self.OnLoadComplete))) {
                error("Period isn't Loaded or Loading.. Can't determine Tags");
                return;
            }

            var loadWait: Promise<any> = undefined
            if (self.bIsLoaded) {
                loadWait = ASync.resolve(self)
            } else {
                loadWait = self.OnLoadComplete
            }

            loadWait
                .then((aPeriodBO) => {
                    if (!(aPeriodBO.bIsLoaded)) {
                        error("Waited on Period Load to complete but still isn't Loaded");
                        return
                    }
                    return self.dbContext.findAll(esWB_Tag_Source, {TAG_SOURCE_ID: 'CUSTOMER'})
                })
                .then((sourceRows: WB_TagSourceRow[]) => {
                    let source_id = 0
                    if (sourceRows) {
                        source_id = sourceRows[0].cif.WB_TAG_SOURCE_ID
                    }
                    return self.dbContext.findAll(esWB_Tag, {WB_TAG_SOURCE_ID: source_id})
                })
                .then((arrResultRows: WB_TagRow[]) => {
                    if (!_.isEmpty(arrResultRows)) {
                        self._AllTags = arrResultRows
                    } else {
                        self._AllTags = []
                    }

                    self._bIHaveTagsLoaded = true
                    self._OnIHaveTagsLoaded = undefined
                    resolve(self);
                    return
                })
                .catch((err) => {
                    self._OnIHaveTagsLoaded = undefined
                    error(err)
                });

        })
        return self._OnIHaveTagsLoaded;
    }

    addTag(TagId: number): Promise<void> {
        const self = this
        return new Promise<void>((resolve, error) => {
            var aTagRow: WB_TagRow = undefined
            self.dbContext.find(esWB_Tag, TagId)
                .then((aNewRow: WB_TagRow) => {
                    if (!(aNewRow)) {
                        error("Unable to find Tag to add to Period. " + TagId)
                        return
                    }

                    aTagRow = aNewRow

                    return self.dbContext.createRecordWithKey(esWB_Period_Tag_Relationship)
                })
                .then((aWBPeriodTag: WB_PeriodTagRelationshipRow) => {
                    //
                    if (!(aWBPeriodTag)) {
                        error("Unable to create Event Tag record add to Period. ")
                        return
                    }
                    aWBPeriodTag.setDefaults()
                    aWBPeriodTag.WB_TagRow = aTagRow
                    aWBPeriodTag.cif.WB_TAG_ID = aTagRow.cif.WB_TAG_ID
                    aWBPeriodTag.cif.WB_PERIOD_ID = self.drWB_Period.cif.WB_PERIOD_ID
                    aWBPeriodTag.cif.TAG_METHOD = "Manual"
                    aWBPeriodTag.WB_TagRow = aTagRow
                    self.dbContext.add(esWB_Period_Tag_Relationship, aWBPeriodTag)
                    self.TagsChanged.next(self)
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })

    }

    removeTag(TagId: number): void {
        const self = this
        var changed = false
        _.forEach(this.drWB_Period.WB_PeriodTagRelationshipRows, (aWBPeriodTagRow: WB_PeriodTagRelationshipRow) => {
            if (aWBPeriodTagRow && aWBPeriodTagRow.isActive && aWBPeriodTagRow.WB_TagRow) {
                if (aWBPeriodTagRow.WB_TagRow.cif.WB_TAG_ID == TagId) {
                    aWBPeriodTagRow.markDeleted()
                    changed = true
                }
            }
        })

        if (changed) {
            self.TagsChanged.next(self)
        }
    }

    hasTag(TagId: number): boolean {
        var found = false

        _.forEach(this.drWB_Period.WB_PeriodTagRelationshipRows, (aWBPeriodTagRow: WB_PeriodTagRelationshipRow) => {
            if (aWBPeriodTagRow && aWBPeriodTagRow.isActive && aWBPeriodTagRow.WB_TagRow) {
                if (aWBPeriodTagRow.WB_TagRow.cif.WB_TAG_ID == TagId) {
                    found = true
                    return false // stop iterating
                }
            }
        })

        return found
    }

    setDateRange(TagId: number, DateRange: IDateRange): void {
        _.forEach(this.drWB_Period.WB_PeriodTagRelationshipRows, (aWBPeriodTagRow: WB_PeriodTagRelationshipRow) => {
            if (aWBPeriodTagRow && aWBPeriodTagRow.isActive && aWBPeriodTagRow.WB_TagRow) {
                if (aWBPeriodTagRow.WB_TagRow.cif.WB_TAG_ID == TagId) {
                    aWBPeriodTagRow.cif.EFFECTIVE_START_DT = DateRange.StartDt.getFullYear().toString() + ('0' + (DateRange.StartDt.getMonth() + 1)).slice(-2) + ('0' + DateRange.StartDt.getDate()).slice(-2)
                    aWBPeriodTagRow.cif.EFFECTIVE_END_DT = DateRange.EndDt.getFullYear().toString() + ('0' + (DateRange.EndDt.getMonth() + 1)).slice(-2) + ('0' + DateRange.EndDt.getDate()).slice(-2)
                    return
                }
            }
        })
    }

    getDateRange(TagId: number): IDateRange {
        let aDateRange: IDateRange = {}
        _.forEach(this.drWB_Period.WB_PeriodTagRelationshipRows, (aWBPeriodTagRow: WB_PeriodTagRelationshipRow) => {
            if (aWBPeriodTagRow && aWBPeriodTagRow.isActive && aWBPeriodTagRow.WB_TagRow) {
                if (aWBPeriodTagRow.WB_TagRow.cif.WB_TAG_ID == TagId) {
                    aDateRange.StartDt = new Date(Number(aWBPeriodTagRow.cif.EFFECTIVE_START_DT.slice(0, 4)), Number(aWBPeriodTagRow.cif.EFFECTIVE_START_DT.slice(4, 6)) - 1, Number(aWBPeriodTagRow.cif.EFFECTIVE_START_DT.slice(6, 8)))
                    aDateRange.EndDt = new Date(Number(aWBPeriodTagRow.cif.EFFECTIVE_END_DT.slice(0, 4)), Number(aWBPeriodTagRow.cif.EFFECTIVE_END_DT.slice(4, 6)) - 1, Number(aWBPeriodTagRow.cif.EFFECTIVE_END_DT.slice(6, 8)))

                    return aDateRange
                }
            }
        })

        return aDateRange
    }


//</editor-fold>

};
PAEnvironment.registerBusinessObjectClass(PeriodBO, "PeriodBO", "Period")